import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Eventi() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/events`)
      .then(r => setEvents(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const upcoming = events.filter(e => e.data_evento >= new Date().toISOString().split('T')[0]);
  const past = events.filter(e => e.data_evento < new Date().toISOString().split('T')[0]);

  return (
    <div>
      <section className="hero-wash py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>Eventi</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">Congressi, serate informative e iniziative dello studio</p>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[1,2,3].map(i => <Skeleton key={i} className="h-64 rounded-xl" />)}</div>
          ) : events.length === 0 ? (
            <div className="text-center py-16">
              <Calendar size={48} className="mx-auto text-muted-foreground mb-4" />
              <p className="text-lg font-medium text-[#1F2A37] mb-2" style={{fontFamily:'Space Grotesk'}}>Nessun evento in programma</p>
              <p className="text-muted-foreground">Torna presto per scoprire le nostre prossime iniziative</p>
            </div>
          ) : (
            <>
              {upcoming.length > 0 && (
                <div className="mb-12">
                  <h2 className="text-2xl font-bold text-[#1F2A37] mb-6" style={{fontFamily:'Space Grotesk'}}>Prossimi Eventi</h2>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {upcoming.map(e => (
                      <Link to={`/eventi/${e.id}`} key={e.id} className="block">
                      <Card className="overflow-hidden hover:shadow-[var(--shadow-md)] transition-shadow duration-200 cursor-pointer h-full">
                        {e.immagine_url && (
                          <div className="aspect-video overflow-hidden bg-[hsl(var(--muted))]">
                            <img src={e.immagine_url} alt={e.titolo} className="w-full h-full object-cover" />
                          </div>
                        )}
                        <CardContent className="p-5">
                          {e.categoria && <Badge className="mb-2 bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]">{e.categoria}</Badge>}
                          <h3 className="text-lg font-bold text-[#1F2A37] mb-2" style={{fontFamily:'Space Grotesk'}}>{e.titolo}</h3>
                          <div className="space-y-1 text-sm text-muted-foreground mb-3">
                            <p className="flex items-center gap-2"><Calendar size={14} /> {new Date(e.data_evento).toLocaleDateString('it-IT', {day:'numeric', month:'long', year:'numeric'})}</p>
                            {e.ora_inizio && <p className="flex items-center gap-2"><Clock size={14} /> {e.ora_inizio}{e.ora_fine ? ` - ${e.ora_fine}` : ''}</p>}
                            {e.luogo && <p className="flex items-center gap-2"><MapPin size={14} /> {e.luogo}</p>}
                          </div>
                          {e.descrizione && <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">{e.descrizione}</p>}
                        </CardContent>
                      </Card>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              {past.length > 0 && (
                <div>
                  <h2 className="text-2xl font-bold text-[#1F2A37] mb-6" style={{fontFamily:'Space Grotesk'}}>Eventi Passati</h2>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {past.map(e => (
                      <Link to={`/eventi/${e.id}`} key={e.id} className="block">
                      <Card className="overflow-hidden opacity-75 hover:opacity-100 transition-opacity duration-200 cursor-pointer h-full">
                        {e.immagine_url && <div className="aspect-video overflow-hidden bg-[hsl(var(--muted))]"><img src={e.immagine_url} alt={e.titolo} className="w-full h-full object-cover" /></div>}
                        <CardContent className="p-5">
                          {e.categoria && <Badge variant="secondary" className="mb-2">{e.categoria}</Badge>}
                          <h3 className="font-bold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>{e.titolo}</h3>
                          <p className="text-sm text-muted-foreground">{new Date(e.data_evento).toLocaleDateString('it-IT', {day:'numeric', month:'long', year:'numeric'})}</p>
                        </CardContent>
                      </Card>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </div>
  );
}
